// 代理为/api封装请求
import axios from 'axios';
import qs from 'qs';
import store from '../store/index.js'
import router from '../router/index.js'
import webConfig from '../utils/global.config.js';//不需要带token的路由卸写在这个文件
// import {Base64} from 'js-base64';//base64
import ElementUI from 'element-ui';



let request = axios.create({
	//1.基础配置
	baseURL:'/api',
	timeout: 10000,
	responseType:'json',//接口形式为json形式
	headers: {
	    'Content-Type': 'application/x-www-form-urlencoded'  // 设置默认请求头  application/x-www-form-urlencoded   application/json
	},
	transformRequest: [(data, headers) => {
	    
	    return qs.stringify(data);
	}]
	
	
})
request.interceptors.request.use((config) => {
	let whiteList = webConfig.whiteListApi;
	let url = config.url;
	let token = store.state.user.token;
	if (whiteList.indexOf(url) === -1 && token) {
	
		config.headers.token = token 	// 不在白名单并且token也存在
	}
	return config;
},error =>{
	
	return Promise.reject(new Error(error))
})
request.interceptors.response.use((res) => {

	const status = res.status || 200
	
	const message = res.data.msg || '未知错误'
	if (status === 200) {
		if (res.data.code == '203' && (res.data.message == '请重新登录' || res.data.message == '请先登录')) {

			 ElementUI.Message.error(res.data.message);
			 // 先读取用户类型（LOGOUT 会清空 user 对象，必须在 LOGOUT 之前读取）
			 const userType = store.state.user.user?.user_type;
			 // 清除所有用户信息和token
			 store.commit('user/LOGOUT');
			 // 只有当前路由需要登录时才跳转到登录页
			 const currentRoute = router.currentRoute;
			 if (currentRoute.meta?.isLogin) {
				 // 根据用户类型判断跳转路径，委托方跳转到委托方登录页
				 const loginPath = userType === 'entrust' ? '/weiTuo' : '/huiShou';
				 // 跳转到登录页，携带当前路径便于登录后返回
				 router.push({
					 path: loginPath,
					 query: {
						 redirect: currentRoute.fullPath
					 }
				 });
			 }
			 return Promise.reject(new Error(res.data.message));
		}else{
			return res
		}
		
	}else if (status === 401) {
		
		alert("你没有权限");
		// 跳转到重新登录页面
		return Promise.reject(new Error(message));
	}else{
		
		return Promise.reject(new Error(message));
	}
},error => {
	ElementUI.Message.error('页面出错');
	return Promise.reject(new Error(error))
})













export default request



